import { Extension } from '@tiptap/core';

export interface ImageUploaderPluginOptions {
  acceptMimes: string[];

  upload(
    editorId: string,
    file: File | string,
    resourceType: string,
    parentResourceType: string,
    parentResourceId: string,
    id?: string
  ): Promise<Object>;

  id(): string;

  ignoreDomains: string[];

  editorId: string;
  editor: any;
  resourceId: string;
  resourceType: string;
  parentResourceType: string;
  parentResourceId: string;
  emitter?: any;
  preventInsertFiles?: boolean;
}

export interface ImageUploaderOptions {
  getRandId: () => string;
  imageUploader: any;
  getFileCache: any;
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    imageUploadExtension: {
      /** Add an image */
      uploadImage: (options: { file: File }) => ReturnType;
    };
  }
}

export const ImageUploadExtension = ({
  getRandId,
  getFileCache,
  imageUploader,
}: ImageUploaderOptions) =>
  Extension.create<ImageUploaderPluginOptions>({
    name: 'imageUploadExtension',

    addOptions() {
      return {
        id: () => getRandId(),
        acceptMimes: [
          'image/jpeg',
          'image/gif',
          'image/png',
          'image/jpg',
          'image/avif',
          'image/webp',
          'image/svg+xml',
        ],
        upload: () => Promise.reject(new Error('【ImageUploadExtension】upload')),
        ignoreDomains: [],
        editorId: '',
        resourceId: '',
        resourceType: '',
        parentResourceType: '',
        parentResourceId: '',
        editor: {} as any,
      };
    },

    addCommands() {
      return {
        uploadImage:
          (options) =>
          ({ tr }) => {
            tr.setMeta('uploadImages', options.file);
            return true;
          },
        getFileCache: (key: string) => () => {
          return getFileCache(key);
        },
      };
    },

    addProseMirrorPlugins() {
      const options = {
        ...this.options,
        resourceId: this.options.resourceId,
        resourceType: this.options.resourceType,
        editor: this.editor as any,
      };
      return [imageUploader(options)];
    },
  });
